// extracted by mini-css-extract-plugin
export default {"listaSuspensa":"ListaSuspensa_listaSuspensa__0s8k1","campoInput":"ListaSuspensa_campoInput__UMoZ9","opcoes":"ListaSuspensa_opcoes__PcJo+"};